import StvJaNeinUnbekannt from "../../../../../consumer/form/dto/StvJaNeinUnbekannt";
import InputValidationStateBo from "../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../form/input/InputValidatorI";

export default class HundeRasseValidator implements InputValidatorI {

    private rasse?: string

    private vericherbar?: StvJaNeinUnbekannt;

    constructor(newRasse?: string, newVericherbar?: StvJaNeinUnbekannt) {
        this.rasse = newRasse;
        this.vericherbar = newVericherbar;
    }

    validate(): InputValidationStateBo {

        // *** exist value
        if (!InputValidator.existValue(this.rasse)) {
            return InputValidationStateBo.createInValid("Bitte geben Sie eine Rasse an.");
        }
        // *** is empty
        if (InputValidator.isBlank(this.rasse)) {
            return InputValidationStateBo.createInValid("Bitte geben Sie eine Rasse an.")
        }

        // 
        if (this.nichtVersicherbar(this.vericherbar)) {
            return InputValidationStateBo.createInValid("Für diese Rasse bieten wir leider keinen Versicherungsschutz an.");
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

    private nichtVersicherbar = (versicherbar?: StvJaNeinUnbekannt) => {
        return StvJaNeinUnbekannt.NEIN === versicherbar;
    }


}
